import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { auth, db } from './FirebaseConfig'; 
import { createUserWithEmailAndPassword } from 'firebase/auth';
import { collection, getDocs, deleteDoc, updateDoc, doc, setDoc } from 'firebase/firestore';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import 'bootstrap-icons/font/bootstrap-icons.css';

import './Dashboard.css';
import logo from '../images/Logo.png';

function Dashboard() {
    // States
        const navigate = useNavigate();
        const [accountRequests, setAccountRequests] = useState([]);
        const [admins, setAdmins] = useState([]);

    // Fetch account requests from Firebase Firestore
        useEffect(() => {
            const fetchAccountRequests = async () => {
                try {
                    const querySnapshot = await getDocs(collection(db, 'accountRequests')); 
                    const requests = querySnapshot.docs.map(doc => ({
                        id: doc.id,
                        ...doc.data()
                    }));
                    console.log("Fetched account requests: ", requests); 
                    setAccountRequests(requests); 
                } catch (error) {
                    console.error("Error fetching data:", error);
                }
            };

            fetchAccountRequests(); 
        }, []); 

    // Fetch admins from Firebase Firestore
        useEffect(() => {
            const fetchAdmins = async () => {
                console.log("useEffect is running in fetchAdmins()");

                try {
                    const querySnapshot = await getDocs(collection(db, 'accounts'));
        
                    if (querySnapshot.empty) {
                        console.log("No admins found in Firestore.");
                        setAdmins([]);
                        return;
                    }
        
                    const usersList = querySnapshot.docs.map(doc => ({
                        id: doc.id,
                        name: doc.data().name || "Unknown", // Ensure 'name' exists
                        email: doc.data().email || "No email",
                        position: doc.data().position || "Not specified",
                        password: doc.data().password || "No password"
                    }));
        
                    console.log("Fetched admins:", usersList); // Debugging log
                    setAdmins(usersList);
                } catch (error) {
                    console.error("Error fetching users:", error);
                }
            };
        
            fetchAdmins();
        }, []);

    // Handle Accept
    const handleAccept = async (id, email, password, position) => {
        try {
            const userCredential = await createUserWithEmailAndPassword(auth, email, password);
            const userId = userCredential.user.uid; // Extract user ID
            
            // Update Firestore status
            const userRef = doc(db, 'accountRequests', id);
            console.log('Attempting to update user status to approved');
            await updateDoc(userRef, { status: 'approved' });
            console.log('Successfully updated user status to approved');
            
            console.log(`Attempting to delete account request with ID: ${id}`);
            await deleteDoc(doc(db, 'accountRequests', id));
            console.log(`Successfully deleted account request with ID: ${id}`);

            console.log('Attempting to add user to accounts collection');
            await setDoc(doc(db, 'accounts', userId), {
                id: userId,
                email: email,
                position: position || 'Not specified', 
                createdAt: new Date()
            });
            console.log('Successfully added user to accounts collection');

            alert('Account approved!');

            // Update state
            setAccountRequests(prevRequests => prevRequests.filter(req => req.id !== id));
        } catch (error) {
            alert('Error approving account: ' + error.message);
        }
    };

    // Handle Reject
    const handleReject = async (id) => {
        try {
            await deleteDoc(doc(db, 'accountRequests', id));
            alert('Account request rejected.');
            setAccountRequests(prevRequests => prevRequests.filter(req => req.id !== id));
        } catch (error) {
            alert('Error rejecting account: ' + error.message);
        }
    };

    return (
        <div className="Dashboard-container">
            <div>
                <h1 className="Dashboard-h1">
                    <img src={logo} alt="Company Logo" className="Dashboard-logo" />
                </h1>
            </div>

            <div className="Dashboard-section">
                <h2>Account Requests</h2>
                {accountRequests.length > 0 ? (
                    <ul>
                        {accountRequests.map(request => (
                            <li key={request.id}>
                                <p>
                                    Email: {request.email}
                                    <button className='accept-button' 
                                        onClick={() => handleAccept(request.id, request.email, request.password, request.position)}>
                                        <i className="bi bi-check-square-fill"></i>
                                    </button>
                                    <button className='reject-button' onClick={() => handleReject(request.id)}>
                                        <i className="bi bi-x-square-fill"></i>
                                    </button>
                                </p>
                            </li>
                        ))}
                    </ul>
                ) : (
                    <p>No account requests yet.</p>
                )}
            </div>

            <div className="Dashboard-section">
                <h2>Account Admins</h2>
                <p>Admins length: {admins.length}</p>  {/* DEBUG */}
                {admins.length > 0 ? (
                    <ul>
                        {admins.map(admin => (
                            <li key={admin.id}>
                                <p>Name: {admin.name}</p>
                                <p>Position: {admin.position || 'Not specified'}</p>
                                <p>Email: {admin.email}</p>
                                <p>Password: {admin.password}</p>
                            </li>
                        ))}
                    </ul>
                ) : (
                    <p>No admins found.</p>
                )}
            </div>

            <div className="Dashboard-section">
                <h2>Order Requests</h2>
                <p>Coming Soon...</p>
            </div>
        </div>
    );
}

export default Dashboard;
